import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/objectWithoutPropertiesLoose";
var _excluded = ["rename", "keyname", "visible"];
import React, { useEffect, memo } from 'react';
import { useStore } from './store';
import { jsx as _jsx } from "react/jsx-runtime";
export var Select = /*#__PURE__*/memo(props => {
  var {
    fields = {},
    dispatch
  } = useStore();
  var {
      rename,
      keyname,
      visible = true
    } = props,
    elmProps = _objectWithoutPropertiesLoose(props, _excluded);
  useEffect(() => {
    if (keyname || props.name) {
      var key = keyname || props.name;
      delete fields[key];
      dispatch({
        fields: _extends({}, fields, {
          [key]: visible ? /*#__PURE__*/_jsx("select", _extends({}, elmProps, {
            name: rename || props.name
          })) : null
        })
      });
    }
  }, [props]);
  return null;
});
Select.displayName = 'Login.Select';